import React from 'react';

export default () => (
  <svg width="732" height="503" viewBox="0 0 732 503" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="green">
        <stop stopColor="#5CF1C7" offset="0%" />
        <stop stopColor="#2FDF95" offset="100%" />
      </linearGradient>
      <radialGradient cy="-45.638%" fx="50%" fy="-45.638%" r="121.365%" id="dark">
        <stop stopColor="#135A9F" offset="0%" />
        <stop stopColor="#173757" offset="20.825%" />
        <stop stopColor="#192532" offset="100%" />
      </radialGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(540 396)">
        <ellipse fill="url(#green)" cx="43" cy="42.213" rx="43" ry="42.213" />
        <path
          d="M60.394 18.214H25.428c-2.436 0-4.385 1.885-4.385 4.242V61.1c0 2.357 1.949 4.242 4.385 4.242h34.966c2.437 0 4.386-1.885 4.386-4.242V22.456c0-2.357-1.95-4.242-4.386-4.242zm1.95 42.886c0 1.06-.854 1.885-1.95 1.885H25.428c-1.096 0-1.949-.824-1.949-1.885V22.456c0-1.06.853-1.885 1.95-1.885h34.965c1.096 0 1.95.824 1.95 1.885V61.1zm-30.337-2.827l5.483-4.713-5.483-4.713v9.426zm19.737-19.087c-.975-.942-2.802-2.12-5.848-2.12-3.29 0-6.7.824-9.137 1.649V25.284h-4.874v20.382l3.412-1.532S40.9 41.66 45.774 41.66c2.437 0 3.046 1.296 3.046 2.474v14.139h4.873V44.134c.122-.353.122-2.945-1.95-4.948zm-6.457-6.244h4.873c2.193-2.474 3.29-4.949 3.655-7.658h-4.873c-.488 2.71-1.706 5.184-3.655 7.658z"
          fill="#FFF"
          fillRule="nonzero"
          opacity=".749"
        />
      </g>
      <g transform="translate(646 396)">
        <ellipse fill="url(#green)" cx="42.85" cy="42.213" rx="42.85" ry="42.213" />
        <path
          d="M56.06 33.403c.296.145.543.339.74.557.026.024.026.024.05.024h.025l5.683-2.398c.024-.024.05-.048.05-.073 0-.024 0-.048-.026-.072l-5.312-5.209c-.024-.024-.05-.024-.05-.024h-.024c-.025 0-.05.024-.05.073l-1.16 7.05c.024.023.049.072.074.072zm-11.786-4.724c.272.412.445.896.494 1.38 0 .025.025.05.05.074l8.45 3.56h.024c.025 0 .05 0 .05-.024a2.63 2.63 0 0 1 .865-.436c.024 0 .049-.024.049-.072l1.384-8.503c0-.024 0-.049-.025-.073l-5.288-5.208c-.024-.024-.024-.024-.049-.024s-.05.024-.05.048l-5.954 9.157c-.025.048-.025.097 0 .121zm28.859 13.105l-9.068-8.914c-.025-.024-.05-.024-.05-.024h-.024l-6.152 2.592c-.025.024-.05.048-.05.072 0 .025.025.073.05.073l15.17 6.37h.025c.025 0 .05 0 .05-.023l.049-.049c.05 0 .05-.072 0-.097zm-1.507 1.454l-14.553-6.105h-.025c-.025 0-.05 0-.074.025-.395.532-.988.872-1.68.969-.025 0-.074.024-.074.072l-1.557 9.472c0 .024 0 .048.025.073.543.411.864 1.017.939 1.695 0 .049.024.073.074.073l8.796 1.817h.024c.025 0 .05 0 .05-.025l8.055-7.92c.024-.025.024-.05.024-.073 0-.025 0-.049-.024-.073zm-19.273-8.091l-7.955-3.343h-.025c-.025 0-.05.024-.074.048a2.916 2.916 0 0 1-2.446 1.309c-.149 0-.297-.025-.47-.049h-.024c-.025 0-.05.024-.075.049l-6.547 10.053a.073.073 0 0 0 0 .097c.025.024.05.024.074.024h.025l17.468-7.389c.025-.024.05-.048.05-.072v-.218c0-.146.024-.291.049-.412 0-.049-.025-.073-.05-.097zm9.587 17.587l-7.733-1.575h-.025c-.025 0-.05.024-.074.024a2.662 2.662 0 0 1-1.112.824c-.025 0-.05.048-.05.073l-1.853 11.288c0 .049.025.073.05.097h.05c.024 0 .049 0 .049-.024l10.723-10.538c.024-.024.024-.048.024-.072 0-.073-.024-.097-.049-.097zm-10.797-.775c-.741-.291-1.285-.945-1.483-1.696 0-.024-.024-.049-.074-.073l-14.33-2.931h-.025c-.025 0-.05.024-.074.048-.074.122-.124.219-.198.315a.073.073 0 0 0 0 .097L48.005 66.42c.025.025.025.025.05.025.024 0 .049 0 .049-.025l.79-.775c0-.024.025-.024.025-.048l2.224-13.566c.05 0 .05-.048 0-.072zm-15.59-6.42c0 .049.024.073.073.073l14.207 2.907h.025c.025 0 .05-.025.074-.049.42-.726 1.161-1.211 2.001-1.26.05 0 .075-.024.075-.072l1.531-9.326c0-.025 0-.073-.049-.073-.099-.073-.198-.145-.321-.267-.025-.024-.05-.024-.05-.024h-.024l-17.567 7.437c-.05.024-.05.049-.05.097.025.194.074.363.074.557zm-5.955 2.35a3.543 3.543 0 0 1-.223-.315c-.024-.024-.05-.048-.074-.048h-.025l-6.127 2.591c-.025 0-.05.025-.05.049s0 .048.025.073l2.99 2.93c.025.025.05.025.05.025.024 0 .049-.024.073-.048l3.385-5.209s0-.024-.024-.048zm4.052.945c-.025-.025-.05-.049-.074-.049h-.025c-.445.194-.89.29-1.359.29-.37 0-.717-.048-1.087-.169h-.025c-.025 0-.05.025-.074.049l-3.558 5.474-.025.025a.073.073 0 0 0 0 .097L43.78 70.61c.025.024.05.024.05.024.024 0 .049 0 .049-.024l2.866-2.834a.073.073 0 0 0 0-.097L33.65 48.834zm-2.298-6.323c.025.024.05.049.074.049h.025c.247-.049.519-.097.766-.097.271 0 .568.048.84.12h.024c.025 0 .05-.023.075-.048l6.621-10.174a.073.073 0 0 0 0-.097 2.836 2.836 0 0 1-.741-2.64c0-.049-.025-.073-.05-.097-.84-.363-8.276-3.464-8.276-3.488h-.025c-.025 0-.05 0-.05.024l-6.3 6.201a.073.073 0 0 0 0 .097l7.017 10.15zm.716-17.732s7.512 3.15 7.833 3.295h.025c.024 0 .024 0 .049-.025a3.023 3.023 0 0 1 1.853-.654c.321 0 .642.049.964.146h.024c.025 0 .05-.025.074-.049l6.103-9.375a.073.073 0 0 0 0-.097l-5.065-4.965c-.025-.025-.025-.025-.05-.025-.024 0-.049 0-.049.025L32.07 24.634c-.025.024-.025.048-.025.072-.025.049 0 .049.024.073zm-2.915 19.5c.025 0 .05-.024.074-.048.148-.29.37-.557.593-.8a.073.073 0 0 0 0-.096c-.074-.097-6.77-9.69-6.77-9.714-.025-.024-.025-.024-.074-.049-.025 0-.05 0-.05.025L15.12 41.25c-.025.025-.025.049-.025.073 0 .024.025.049.074.049l13.985 2.906c-.025 0-.025 0 0 0zm-.642 1.672c0-.049-.025-.073-.075-.073l-12.131-2.495h-.025c-.024 0-.05.024-.074.049-.025.024 0 .072.025.097l5.41 5.329c.026.024.05.024.05.024h.025l6.72-2.834c.05-.049.075-.073.075-.097z"
          fill="#FFF"
          fillRule="nonzero"
          opacity=".753"
        />
      </g>
      <text fontSize="24" fontWeight="700" fill="#3FA2F7" transform="translate(2 -5)">
        <tspan x="57" y="143">
          Content
        </tspan>
      </text>
      <text fontSize="12" fontWeight="600" fill="#2FDF95" transform="translate(2 -5)">
        <tspan x="616" y="154">
          Gatsby.js
        </tspan>
      </text>
      <text fontSize="12" fontWeight="600" fill="#2FDF95" transform="translate(2 -5)">
        <tspan x="550" y="163">
          GraphQL
        </tspan>
      </text>
      <text fontSize="12" fontWeight="600" fill="#2FDF95" transform="translate(2 -5)">
        <tspan x="561" y="504">
          Heroku
        </tspan>
      </text>
      <text transform="rotate(20 380.242 361.601)" fontSize="15" fontWeight="600" fill="#2FDF95">
        <tspan x="233.064" y="363.43">
          Webhook notification to trigger builds
        </tspan>
      </text>
      <text transform="rotate(-20 367.139 156.77)" fontSize="15" fontWeight="600" fill="#2FDF95">
        <tspan x="271.317" y="169.942">
          Fetch content from Delivery API
        </tspan>
      </text>
      <text fontSize="12" fontWeight="700" fill="#2FDF95" transform="translate(2 -5)">
        <tspan x="561" y="386">
          Static site hosting options
        </tspan>
      </text>
      <text fontSize="12" fontWeight="600" fill="#2FDF95" transform="translate(2 -5)">
        <tspan x="671" y="505">
          Netlify
        </tspan>
      </text>
      <text fontSize="24" fontWeight="700" fill="#2FDF95" transform="translate(2 -5)">
        <tspan x="611" y="24">
          Build
        </tspan>
      </text>
      <text fontSize="24" fontWeight="700" fill="#2FDF95" transform="translate(2 -5)">
        <tspan x="589" y="366">
          Hosting
        </tspan>
      </text>
      <g transform="translate(2 159)">
        <path
          d="M101.5 203c56.057 0 101.5-45.443 101.5-101.5S157.557 0 101.5 0 0 45.443 0 101.5 45.443 203 101.5 203z"
          stroke="#3FA2F7"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="1,7"
        />
        <circle fill="url(#dark)" cx="101" cy="101" r="93" />
        <path
          d="M87.354 115.862l.007-.007c-3.89-3.925-6.288-9.328-6.265-15.27.02-5.953 2.46-11.338 6.385-15.228l-.011-.01c3.322-3.298 3.342-8.665.044-11.982a8.474 8.474 0 0 0-11.988-.046c-7.002 6.944-11.35 16.563-11.389 27.204-.039 10.64 4.235 20.285 11.186 27.28a8.472 8.472 0 0 0 11.987.044c3.325-3.292 3.345-8.658.046-11.983l-.002-.002z"
          fill="#FFD85F"
        />
        <path
          d="M87.47 85.349l.008.009c3.923-3.89 9.326-6.288 15.268-6.267a21.494 21.494 0 0 1 15.228 6.385l.01-.012c3.3 3.325 8.665 3.345 11.982.046a8.477 8.477 0 0 0 .047-11.99c-6.945-7.001-16.564-11.349-27.202-11.388-10.643-.04-20.288 4.237-27.283 11.186a8.479 8.479 0 0 0-.044 11.99c3.292 3.323 8.661 3.342 11.983.043l.002-.002z"
          fill="#3BB4E7"
        />
        <path
          d="M117.869 115.976l-.01-.007c-3.922 3.888-9.326 6.288-15.267 6.265a21.475 21.475 0 0 1-15.226-6.385l-.012.011c-3.301-3.324-8.665-3.345-11.982-.043a8.474 8.474 0 0 0-.047 11.987c6.945 7.002 16.564 11.35 27.202 11.389 10.643.039 20.288-4.237 27.283-11.186a8.479 8.479 0 0 0 .044-11.99c-3.292-3.321-8.661-3.342-11.983-.043l-.002.002z"
          fill="#ED5C68"
        />
        <path
          d="M87.47 85.348a8.474 8.474 0 0 1-11.988-.047 8.47 8.47 0 0 1 .044-11.982 8.477 8.477 0 0 1 11.99.046c3.296 3.317 3.275 8.684-.047 11.983"
          fill="#308BC5"
        />
        <path
          d="M87.311 127.848a8.476 8.476 0 0 1-11.987-.044c-3.299-3.32-3.278-8.684.044-11.985a8.479 8.479 0 0 1 11.99.047 8.472 8.472 0 0 1-.047 11.982"
          fill="#D5465F"
        />
      </g>
      <path
        d="M209.5 311.5l311.273 115.592M539.5 118.5l-312 113M629.5 159.5v166"
        stroke="#2FDF95"
        strokeWidth="3"
        fill="#2FDF95"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="1,7"
      />
      <path
        d="M522.095 434.153l7.307-3.407-3.355-7.746M219.937 229.05l-2.087 7.788 8.09 2.409M624 328.101l5.7 5.701 6.132-5.802"
        stroke="#47E9AF"
        strokeWidth="3"
        strokeLinecap="square"
      />
      <g transform="translate(549 78)">
        <circle
          stroke="#FBE3E2"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="29.5"
          cy="29.5"
          r="29.5"
        />
        <circle fill="url(#green)" cx="30" cy="29" r="25" />
        <g fillRule="nonzero" fill="#FFF" opacity=".752">
          <path d="M18.988 36.482l-1.11-.623 12.36-20.848 1.109.624z" />
          <path d="M17.879 34.83h26.094v.827H17.88z" />
          <path d="M31.431 43.09l-12.71-7.246.658-1.126 12.71 7.245-.658 1.126zm11.042-18.883l-12.71-7.244.658-1.126 12.71 7.245-.658 1.125z" />
          <path d="M19.384 24.92l-.663-1.22 12.804-7.863.664 1.222z" />
          <path d="M41.979 36.482L29.138 15.635l1.152-.624 12.841 20.848-1.152.623zM18.72 21.814h1.33V35.72h-1.33V21.814zm22.322 0h1.331V35.72h-1.33V21.814z" />
          <path d="M31.088 41.437l-.583-.892 11.202-5.714.583.892z" />
          <path d="M44.435 37.102c-.765 1.303-2.47 1.748-3.801.999a2.696 2.696 0 0 1-1.02-3.722c.765-1.303 2.47-1.748 3.801-1 1.34.758 1.794 2.42 1.02 3.723M22.23 24.547c-.765 1.303-2.47 1.748-3.801.999a2.696 2.696 0 0 1-1.02-3.722c.765-1.303 2.47-1.748 3.801-.999 1.331.757 1.786 2.42 1.02 3.722m-4.814 12.555c-.765-1.303-.31-2.965 1.02-3.722 1.332-.75 3.03-.304 3.802.999.766 1.303.311 2.965-1.02 3.722-1.339.749-3.036.304-3.802-1m22.205-12.554c-.765-1.303-.31-2.965 1.02-3.722 1.332-.749 3.03-.304 3.802 1 .766 1.302.311 2.964-1.02 3.721-1.33.749-3.036.304-3.802-.999m-8.695 20.194c-1.538 0-2.782-1.217-2.782-2.723 0-1.506 1.244-2.724 2.782-2.724s2.782 1.218 2.782 2.724c0 1.498-1.244 2.723-2.782 2.723m0-25.11c-1.538 0-2.782-1.217-2.782-2.723 0-1.506 1.244-2.723 2.782-2.723s2.782 1.217 2.782 2.723c0 1.506-1.244 2.724-2.782 2.724" />
        </g>
      </g>
      <g transform="translate(595 34)">
        <circle
          stroke="#FBE3E2"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="47"
          cy="47"
          r="47"
        />
        <circle fill="url(#green)" cx="46.5" cy="47.5" r="42.5" />
        <g fillRule="nonzero">
          <path d="M66.536 47.5h-12.75v3.643h8.743c-1.275 5.464-5.283 10.018-10.565 11.84L31.018 42.035c2.186-6.375 8.378-10.929 15.482-10.929 5.464 0 10.382 2.732 13.479 6.922l2.732-2.368c-3.643-4.918-9.472-8.197-16.211-8.197-9.471 0-17.486 6.74-19.49 15.665L51.055 67.17c8.742-2.185 15.482-10.2 15.482-19.671zM26.464 47.682c0 5.1 2.004 10.018 5.829 13.843 3.825 3.825 8.925 5.829 13.843 5.829L26.464 47.682z" />
          <path
            d="M46.5 22C32.475 22 21 33.475 21 47.5S32.475 73 46.5 73 72 61.525 72 47.5 60.525 22 46.5 22zM32.293 61.707c-3.825-3.825-5.829-8.925-5.829-13.843l19.854 19.672c-5.1-.182-10.2-2.004-14.025-5.829zM50.87 66.99l-23.86-23.86c2.003-8.925 10.018-15.665 19.489-15.665 6.74 0 12.568 3.279 16.21 8.197l-2.731 2.368c-3.097-4.19-8.015-6.922-13.479-6.922-7.104 0-13.114 4.554-15.482 10.929l20.946 20.946c5.282-1.821 9.29-6.375 10.565-11.84h-8.743V47.5h12.75c0 9.471-6.74 17.486-15.665 19.49z"
            fillOpacity=".75"
            fill="#FFF"
          />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/infographic.es6.js